<template>
   <div class="comment">
      <div class="message">
         <span class="bigquotes quotes-left"> &ldquo;&nbsp; </span>
         <span class="text" v-html="comment.content.textDisplay"></span>
         <span class="bigquotes quotes-right"> &nbsp;&rdquo; </span>
      </div>
      <div class="meta">
         <div class="author" :title="comment.content.authorDisplayName">
            {{ comment.content.authorDisplayName }}
         </div>
         <div class="likes">
            <span class="likes-icon">&#x25B2;&nbsp;</span>
            {{ likesCount }}
         </div>
         <timeago :datetime="timestamp" :auto-update="60"/>
      </div>
   </div>
</template>

<script>
const AppLib = require("../../../library/applib.js");

export default {
   name: "Comment",
   props: ["comment"],
   computed: {
      timestamp() {
         return this.comment.content.publishedAt;
      },
      likesCount() {
         const statArray = this.comment.stats || [];
         const lastStat = statArray[statArray.length - 1] || {};
         const likes = lastStat.likes || 0;
         return AppLib.scaleFormatNumber(likes, 1);
      }
   }
};
</script>

<style scoped>
.comment {
   padding: 0.3rem 1.6rem;
}
.message {
   display: flex;
   text-align: left;
}
.bigquotes {
   display: inline-block;
   font-size: 1.6rem;
   font-family: Cookie, cursive;
   align-self: flex-end;
   opacity: 0.4;
}
.quotes-left {
   align-self: start;
   margin-top: -0.5rem;
}
.quotes-right {
   align-self: flex-end;
   margin-bottom: -1.3rem;
}
.text {
   display: inline-block;
   padding: 0rem 0.5rem;
   font-size: 0.88rem;
   color: #444;
}
.meta {
   display: flex;
   flex-direction: column;
   margin-left: 3rem;
   font-size: 0.86rem;
}
.author {
   font-size: 0.9rem;
   opacity: 0.5;
   padding-top: 0.3rem;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}
.likes {
   display: flex;
   align-items: center;
   color: green;
   margin-top: 0.3rem;
   opacity: 0.9;
}
.likes-icon {
   font-size: 0.7rem;
}
@media screen and (max-width: 768px) {
   .comment {
      padding: 0.3rem 0.8rem;
   }
   .author {
      font-size: 0.8rem;
   }
   .text {
      font-size: 0.8rem;
   }
}
</style>



// WEBPACK FOOTER //
// src/components/site/Comment.vue